'use client';

import { c as _c } from "react/compiler-runtime";
import { useMedia } from '@/context/MediaContext';
import { getMediaSourceType } from '@/utils/mediaUtils';
import MediaFrame from './MediaFrame';
import VideoJSPlayer from './players/VideoJSPlayer';
const MediaController = () => {
  const $ = _c(21);
  const {
    state,
    actions
  } = useMedia();
  const {
    isVisible,
    isPlaying,
    currentMedia,
    volume,
    isMuted,
    metadata
  } = state;
  const {
    hidePlayer,
    updateTime,
    setPlayingState
  } = actions;
  const t0 = currentMedia || "";
  let t1;
  if ($[0] !== t0) {
    t1 = getMediaSourceType(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sourceType = t1;
  let t2;
  if ($[2] !== hidePlayer) {
    t2 = () => {
      hidePlayer();
    };
    $[2] = hidePlayer;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleMediaFrameClose = t2;
  let t3;
  if ($[4] !== updateTime) {
    t3 = (currentTime_0, duration_0) => {
      updateTime(currentTime_0, duration_0);
    };
    $[4] = updateTime;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleTimeUpdate = t3;
  const handleError = _temp;
  const t4 = metadata?.title || "";
  let t5;
  if ($[6] !== currentMedia || $[7] !== handleTimeUpdate || $[8] !== isMuted || $[9] !== isPlaying || $[10] !== isVisible || $[11] !== metadata?.cover || $[12] !== setPlayingState || $[13] !== sourceType || $[14] !== volume) {
    t5 = isVisible && <VideoJSPlayer sources={{
      src: currentMedia,
      type: sourceType
    }} options={{
      autoPlay: isPlaying,
      controls: true,
      responsive: true,
      liveui: true,
      fluid: true,
      volume,
      muted: isMuted,
      preload: "auto",
      aspectRatio: "16:9",
      experimentalSvgIcons: true,
      html5: {
        vhs: {
          overrideNative: true,
          enableLowInitialPlaylist: true,
          enableLowLatencyMode: true,
          llhls: true,
          smoothQualityChange: true,
          limitRenditionByPlayerDimensions: true,
          maxPlaylistRetries: 5,
          liveBackBufferLength: 10,
          liveSyncDuration: 1.5
        }
      },
      liveTracker: {
        trackingThreshold: 10,
        liveTolerance: 5
      },
      controlBar: {
        pictureInPictureToggle: true
      }
    }} poster={metadata?.cover || ""} onTimeUpdate={t => handleTimeUpdate(t.currentTime, t.duration)} onError={handleError} onPlay={() => setPlayingState(true)} onPause={() => setPlayingState(false)} isPlaying={isPlaying} />;
    $[6] = currentMedia;
    $[7] = handleTimeUpdate;
    $[8] = isMuted;
    $[9] = isPlaying;
    $[10] = isVisible;
    $[11] = metadata?.cover;
    $[12] = setPlayingState;
    $[13] = sourceType;
    $[14] = volume;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== handleMediaFrameClose || $[17] !== isVisible || $[18] !== t4 || $[19] !== t5) {
    t6 = <MediaFrame title={t4} isVisible={isVisible} onClose={handleMediaFrameClose}>{t5}</MediaFrame>;
    $[16] = handleMediaFrameClose;
    $[17] = isVisible;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
export default MediaController;
function _temp(error_0) {
  console.error("Media Player Error:", error_0);
}